import { APIMethod, fetchData } from "@client";

export async function refreshUserDataQuery() {
  return await fetchData("/user", APIMethod.GET);
}